/* eslint-disable react-hooks/exhaustive-deps */

import { Grid } from "@material-ui/core"
import {
  Modal,
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
} from "App/Component/ui"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants"
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  titleModal,
} from "App/utils/helpers"
import React, { useContext, useEffect, useState } from "react"
import { getTotal, getTotalFilterID, hitungDiskon } from "../.."
import { numberToFixed } from "../.."
import { FormContext } from "../../../context/FormContext"
import { v4 as uuidv4 } from "uuid"
import { getJasaDokterByMsJasa } from "App/Component/layout/MasterData/MasterPenjualan/Jasa/ui/ModalJasaDokter"
import { MSG_NOT_MINUS } from "utils/all"
import AlertDiskon from "../../AlertDiskon"

export const urlGetJasaByKelas = "/penjualan/listJasaByKelasId"
export const urlDelete = "/penjualan/deleteJasa"
export const urlGet = "/penjualan/listJasaByPenjualanId"

export const RESET_STATE_DAFTAR_JASA = {
  id: "",
  mh_jasa_id: "",
  jasa_id: "",
  qty: "",
  keterangan: "",
  harga: "",
  hargaCustom: "",
  hargaCustom2: "",
  kelas_id: "",

  namaJasa: "",
  doctor_id: null,
  doctor_name: "Pilih Dokter",

  diskon: 0,
  nilai_diskon: 0, //hargaCustom*diskon/100
  total_harga_pokok: 0, //hargaBeli*qty
  total_harga_jual: 0, //(hargaCustom-nilai_diskon)*qty
}

export const deleteJasaById = async (formData) => {
  try {
    const res = await instance3.post(urlDelete, formData)

    if (res.data.status === 200) {
      return {
        state: true,
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getJasaByPenjualanID = async (id) => {
  try {
    const res = await instance3.get(`${urlGet}/${id}`)
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
        message: res.data.message,
      }
    } else if (res.data.status === 204) {
      return {
        state: true,
        data: [],
        message: res.data.message,
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "40px",
  },
  {
    id: "namaMsJasa",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "harga_jual",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namaJsJasa",
    disablePadding: false,
    label: "JENIS",
    align: "left",
    minWidth: "100px",
  },
]

export const getAllJasaByKelas = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.post(`${urlGetJasaByKelas}`, {
      kelasId: formFilter.kelas_id,
      asuransiId: formFilter.asuransi_id,
      namaMsJasa: formFilter.name,
      halaman: pages,
      jumlah: limit,
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const ModalDaftarJasa = ({
  setShowModal,
  formJasa,
  setFormJasa,
  setNewJasaDijual,
  setNewDataJasaByKelas,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)

  const { formData, setFormData } = useContext(FormContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      if (isNull(formJasa.qty)) {
        defaultToastError("Qty harus diisi")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else if (
        isNull(formJasa.diskon) ||
        convertToValidPrice(formJasa.diskon) < 0
      ) {
        defaultToastError("Diskon tidak boleh kosong dan kurang dari 0")
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        if (convertToValidPrice(formJasa.qty) > 0) {
          if (isNull(formJasa.doctor_id)) {
            defaultToastError("Dokter tidak boleh kosong")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            if (isNull(formJasa.id)) {
              await addJasa()
            } else {
              const filterJasa = formData.jasa.filter(
                (e) => e.id !== formJasa.id,
              )
              const newSingleJasa = setSingleJasa("UPDATE")
              const newJasa = [...filterJasa, newSingleJasa]
              if (!isNull(formData.penjualan_id)) {
                await addJasaServer(newSingleJasa, "/penjualan/updateJasa")
                setShowModal(false)
              } else {
                setNewJasaDijual(newJasa, false)
                setShowModal(false)
                defaultToastSuccess("Berhasil mengubah list jasa")
              }
            }
          }
        } else {
          if (convertToValidPrice(formJasa.qty) < 0) {
            defaultToastError(MSG_NOT_MINUS)
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (convertToValidPrice(formJasa.qty) === 0) {
            defaultToastError("QTY tidak boleh 0")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else if (isNull(formJasa.hargaCustom2)) {
            defaultToastError("Harga harus diisi")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          } else {
            defaultToastError("Inputan tidak valid")
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
          }
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const setSingleJasa = (type) => {
    const diskon = parseFloat(String(formJasa.diskon).replace(",", ".")) || 0
    const { nilaiDiskon, totalHargaJual, totalHargaPokok } = hitungDiskon(
      formJasa,
      "jasa",
    )
    const qty = convertToValidPrice(formJasa.qty)

    const singleJasa = {
      mhJasaId: formJasa.mh_jasa_id,
      qty: qty,
      keterangan: "",
      harga: formJasa.harga,

      hargabeli: convertToValidPrice(formJasa?.hargabeli),
      hargaCustom2: formJasa.hargaCustom2,
      hargaCustom: convertToValidPrice(formJasa.hargaCustom2),

      total: convertToValidPrice(formJasa.hargaCustom2) * qty,

      namaJasa: formJasa.namaJasa,
      jasa_id: formJasa.jasa_id,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,
      doctor_id: formJasa.doctor_id,
      doctor_name: formJasa.doctor_name,

      diskon,
      nilai_diskon: nilaiDiskon,
      total_harga_pokok: totalHargaPokok,
      total_harga_jual: totalHargaJual,
    }

    let newSingleJasa
    if (type === "ADD") {
      newSingleJasa = {
        id: uuidv4(),
        ...singleJasa,
      }
    } else {
      newSingleJasa = {
        id: formJasa.id,
        ...singleJasa,
      }
    }

    return newSingleJasa
  }

  const addJasa = async () => {
    const newSingleJasa = setSingleJasa("ADD")
    const newJasa = [...formData.jasa, newSingleJasa]
    const reload = formData.reload_perhitungan || false

    if (!isNull(formData.penjualan_id)) {
      await addJasaServer(newSingleJasa, "/penjualan/addJasa")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    } else {
      await setFormData({
        ...formData,
        jasa: newJasa,
        reload_perhitungan: !reload,
      })
      defaultToastSuccess("Berhasil menambah jasa")
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      setShowModal(false)
    }
    setNewJasaDijual(newJasa, false)
  }

  const addJasaServer = async (jasa, url) => {
    try {
      const totalJasa = await getTotalFilterID(formData.jasa, jasa.id, "jasa")
      const hargaTotalJasa =
        jasa.qty * convertToValidPrice(jasa.hargaCustom - jasa.nilai_diskon) +
        totalJasa

      const totalBarang = getTotal(formData.barang, "barang")
      const totalRikjang = getTotal(formData.rikjang, "rikjang")
      const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")
      const totalPaket = getTotal(formData.paket, "paket")

      const jumlah =
        totalBarang +
        totalRikjang +
        hargaTotalJasa +
        totalFasilitas +
        totalPaket

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const newJasa = {
        ...jasa,
        penjualanId: formData.penjualan_id,
        harga_total_jasa: numberToFixed(convertToValidPrice(hargaTotalJasa)),
        total_Penjualan: numberToFixed(convertToValidPrice(jumlah)),
        sisa: numberToFixed(convertToValidPrice(total)),
        hargaCustom: numberToFixed(convertToValidPrice(formJasa.hargaCustom2)),
        tax: taxPercent,
        jumlah_tax: numberToFixed(convertToValidPrice(taxNumber)),
        discount: numberToFixed(convertToValidPrice(formData.potongan / total)),
        jumlah_set_discount: potongan,
        nilai_diskon: numberToFixed(jasa?.nilai_diskon || 0),
        total: numberToFixed(jasa?.total || 0),
        total_harga_pokok: numberToFixed(jasa?.total_harga_pokok || 0),
        total_harga_jual:
          numberToFixed(jasa?.hargaCustom || 0) -
          numberToFixed(jasa?.nilai_diskon || 0),
      }
      const res = await instance3.post(url, newJasa)
      if (res.data.status === 200) {
        defaultToastSuccess(res.data.message)
        await setNewJasaDijual(newJasa, false)
        setNewDataJasaByKelas()
      } else {
        defaultToastError(res.data.message)
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    setFormJasa({
      ...formJasa,
      hargaCustom: convertToValidPrice(formJasa.hargaCustom2),
    })
  }, [formJasa.hargaCustom2])

  const dokterList = useDokter(formJasa.jasa_id, formData.dokter_id)

  return (
    <Modal title={`${titleModal(formJasa.id)} Jasa`} show={setShowModal}>
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        {formJasa.id && (
          <AlertDiskon defaultDiskon={formData.diskon?.diskon_jasa ?? 0} />
        )}
        <p className="mt-1 mb-1">{formJasa.namaJasa}</p>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formJasa.id}
          />
          <Grid item sm={6}>
            <InputTextMaster
              name="qty"
              label="BANYAK"
              id="qty"
              value={formJasa.qty}
              onChange={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormJasa({
                    ...formJasa,
                    qty: formatRupiah(val),
                  })
                } else {
                  setFormJasa({
                    ...formJasa,
                    qty: val,
                  })
                }
              }}
              placeholder="Banyak"
              autoFocus={true}
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name="harga"
              label="HARGA"
              id="harga"
              placeholder="0"
              value={formJasa.hargaCustom2}
              onInput={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormJasa({
                    ...formJasa,
                    hargaCustom2: formatRupiah(val),
                  })
                } else {
                  setFormJasa({
                    ...formJasa,
                    hargaCustom2: val,
                  })
                }
              }}
            />
          </Grid>

          <Grid item sm={12}>
            <InputOptionMaster
              name="doctor_id"
              label="DOKTER"
              id="doctor_id"
              withSearch={true}
              data={dokterList}
              value={formJasa.doctor_id}
              labelValue={formJasa.doctor_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormJasa({
                    ...formJasa,
                    doctor_id: null,
                    doctor_name: "Pilih Dokter",
                  })
                } else {
                  setFormJasa({
                    ...formJasa,
                    doctor_id: e.value,
                    doctor_name: e.label,
                  })
                }
              }}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="discount-barang"
              label="DISKON (%)"
              id="discount-barang"
              value={formJasa.diskon}
              onChange={(e) => {
                const raw = e.target.value
                if (raw === "") {
                  return setFormJasa({ ...formJasa, diskon: "" })
                }
                if (/^[0-9]*([.,][0-9]*)?$/.test(raw)) {
                  if (convertToValidPrice(raw) > 100) {
                    return setFormJasa({ ...formJasa, diskon: 100 })
                  } else {
                    return setFormJasa({
                      ...formJasa,
                      diskon: formatRupiah(raw),
                    })
                  }
                }
              }}
              placeholder="0-100"
              error={convertToValidPrice(formJasa.diskon) > 100}
              message="Maksimal 100%"
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name="nilai-discount"
              label="NILAI DISKON"
              id="nilai-discount"
              value={formatRupiah(
                numberToFixed(
                  convertToValidPrice(
                    (convertToValidPrice(formJasa.hargaCustom) *
                      (parseFloat(String(formJasa.diskon).replace(",", ".")) ||
                        0)) /
                      100,
                  ),
                ),
              )}
              disabled
              placeholder="Nilai Diskon"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  )
}

const useDokter = (id, dokterID) => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)
  useEffect(() => {
    ;(async () => {
      const res = await getJasaDokterByMsJasa(id)
      if (res) {
        const data = []

        res.data.map((item) => {
          return data.push({
            value: item.id_dokter,
            label: item.nama_dokter,
          })
        })

        setState(data)

        // console.log(res);
        // const check = res.data.filter((item) => item.id_dokter === dokterID);
        // if (check.length > 0) {
        //   res.data.map((item) => {
        //     return data.push({
        //       value: item.id_dokter,
        //       label: item.nama_dokter,
        //     });
        //   });

        //   setState(data);
        // } else {
        //   data.push({
        //     value: DOKTER_UMUM_ID,
        //     label: "UMUM",
        //   });

        //   setState(data);
        // }
      }
    })()
  }, [id])

  return state
}
